import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { Flag } from './flag';
import styles from './country-option.scss';
const MAX_CHARS = 25;
export function CountryOption(_ref) {
  let {
    callingCode,
    countryName,
    longCountryCode
  } = _ref;
  const visibleCountryName = countryName.length > MAX_CHARS ? `${countryName.substring(0, MAX_CHARS)}...` : countryName;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.countryOption
  }, /*#__PURE__*/React.createElement(Flag, {
    longCountryCode: longCountryCode
  }), /*#__PURE__*/React.createElement(Text, {
    "aria-label": `${countryName} ${callingCode}`
  }, `${visibleCountryName} ${callingCode}`));
}
//# sourceMappingURL=country-option.js.map